import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'

  import { useRoute } from 'vue-router/composables'
  import useCommonMixin from '@/composables/useCommonMixin'
  import useCourse from '@/composables/useCourse'

  import { EditorModule } from '@/store/modules/editor'

  import type { PropType } from 'vue'
  import type { Nullable } from '@/services/interfaces/Content'
  import type { CourseModule, Lesson, EditorStatePayload } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DurationInput',
  props: {
    value: {
      required: true,
      type: Number,
    },
    durationCalibration: {
      type: String,
      default: 'min',
    },
    showCalibration: {
      type: Boolean,
      default: true,
    },
    editTitle: String,
    editSubtext: String,
    editorState: String as PropType<'currentLesson' | 'currentModule' | string>,
    editorProperty: String as PropType<keyof Lesson | keyof CourseModule | string>,
    mutateAndQueueFunc: Function as PropType<(data: EditorStatePayload) => void>,
  },
  emits: ['duration'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const route = useRoute()
  const { revertConvertNumberInput } = useCommonMixin()
  const { currentLesson, currentModule } = useCourse()

  const durationModel = ref(props.value)

  const convertedDuration = computed(() => {
    return revertConvertNumberInput(String(durationModel.value))
  })

  watch(durationModel, () => {
    setDuration(convertedDuration.value || 0)

    // used in create/update course
    emit('duration', convertedDuration.value || 0)
  })

  watch(
    () => props.value,
    (value) => {
      durationModel.value = value
    },
  )

  const setDuration = (duration: number) => {
    if (props.editorProperty && props.editorState) {
      EditorModule.setEditableState({
        key: `${props.editorState}${props.editorProperty}`,
        path: route.path,
        state: props.editorState,
        property: props.editorProperty,
        value: duration,
        mutateAndQueue: props.mutateAndQueueFunc,
      })
    }
  }

  const discardChangesCallback = (
    _data: number | EditorStatePayload,
    stateBeforeChange?: {
      currentLesson: Nullable<Lesson>
      currentModule: Nullable<CourseModule>
      [key: string]: any
    },
  ) => {
    durationModel.value = (stateBeforeChange?.[props.editorState!] as any)?.[props.editorProperty!] || props.value
  }

  const updateStateModel = (data: EditorStatePayload) => {
    durationModel.value = data.value as number
  }

  onBeforeUnmount(() => {
    EditorModule.unsubscribe({ type: 'discard', callback: discardChangesCallback })
  })

  onMounted(() => {
    EditorModule.subscribe({
      type: 'discard',
      key: `${props.editorState}${props.editorProperty}`,
      callback: () =>
        discardChangesCallback(durationModel.value, {
          currentLesson: currentLesson.value,
          currentModule: currentModule.value as CourseModule,
        }),
    })
    EditorModule.subscribe({
      type: 'save',
      key: `${props.editorState}${props.editorProperty}`,
      callback: updateStateModel,
    })
  })

return { __sfc: true,props, emit, route, revertConvertNumberInput, currentLesson, currentModule, durationModel, convertedDuration, setDuration, discardChangesCallback, updateStateModel, computed, onBeforeUnmount, onMounted, ref, watch, useRoute, useCommonMixin, useCourse, EditorModule }
}

})